import TraditionalComparison from "@/components/comparisonWithTraditional";
import { COMPARISON_CONSTANTS_OPERATIONS } from "./constants";

const ComparisonComp = () => {
  return <TraditionalComparison {...COMPARISON_CONSTANTS_OPERATIONS} />;
};

export default ComparisonComp;
